import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PageShell({ children, noFooter = false, className = "" }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className={`flex-1 ${className}`}>{children}</main>
      {!noFooter && <Footer />}
    </div>
  );
}
